import React from 'react'
import PublisherAnalysisContainer from '../../components/PublisherAnalysis/PublisherAnalysisContainer'

// SEO for this page is dynamic (per publisher) and is rendered inside
// PublisherAnalysisContainer once the publisher's name has loaded.
const PublisherAnalysis = () => {
  return (
    <React.Fragment>
      <PublisherAnalysisContainer />
    </React.Fragment>
  )
};

export default PublisherAnalysis